export default __webpack_public_path__ + "static/media/i098vk.ba598e5d.webp";